/**
 * MiniBarChart — single-series compact bar chart.
 * Used by Publisher "Monthly Submissions" mini-chart.
 *
 * Renders inside a fixed viewBox (300×80); scales to container width via width="100%".
 */
interface MiniBarChartProps {
  labels: string[];
  values: number[];
  color?: string;
  height?: number;
}

export function MiniBarChart({ labels, values, color = "var(--terracotta)", height = 80 }: MiniBarChartProps) {
  const W = 300;
  const pT = 8, pB = 20;
  const cH = height - pT - pB;
  const n = labels.length;
  const mx = Math.max(...values, 1) + 1;
  const gW = W / n;
  const bW = Math.min(20, gW * 0.55);

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${W} ${height}`}>
      {values.map((v, i) => {
        const x = i * gW + (gW - bW) / 2;
        const bH = (v / mx) * cH;
        return (
          <g key={i}>
            <rect
              x={x} y={pT + cH - bH}
              width={bW} height={bH}
              rx="3" fill={color} opacity="0.65"
            />
            <text
              x={i * gW + gW / 2} y={height - pB + 13}
              textAnchor="middle" fontSize="9"
              fill="var(--text-tertiary)" fontFamily="var(--font-sans)"
            >
              {labels[i]}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
